import { useMutation, useQueryClient } from 'libs/query'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldValues, UseFormSetError } from 'libs/form'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { StoreSettingsContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { setApiFieldErrors } from 'utils/formErrors'

export const useUpdateStoreMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const storeCtx = useContext(StoreSettingsContext)

	const { mutate: updateStoreMutation, isPending: isUpdateStoreLoading } = useMutation({
		mutationFn: (data: FormData) => {
			// TODO: change to apiRoutes
			return axiosPrivate.patch('/settings/', data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		},
		onSuccess: (res) => {
			useToast({ type: 'success', message: t('Store was updated') })()
			storeCtx?.setStoreSettings(res.data)
			queryClient.invalidateQueries({ queryKey: queryKeys.payoutMethods.all })
		},
		onError: (err: any) => {
			if (err?.response?.status === 400) {
				setApiFieldErrors(setError, err.response.data)
			}

			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		updateStoreMutation,
		isUpdateStoreLoading
	}
}
